import { COLLECTIONS } from "constants/action-types";
import { IDoorTotals, IDoorTotalDelta, IDoorTotalRow } from "reducers/collection";

export const calcBulkDoorTotalsForMatchingRows = (rows, doors, useAsFilteredTotals?: boolean) => {
    return {
        payload: { rows, doors, useAsFilteredTotals },
        type: COLLECTIONS.COLLECTION.DOOR_TOTALS.CALCULATE_FOR_MATCHING_ROWS,
    };
};

export const calcBulkDoorTotalsFilteredForMatchingRows = (rows, doors) => ({
    payload: { rows, doors },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS_FILTERED.CALCULATE_FOR_MATCHING_ROWS,
});

export const calculationsReturnedForMatchingRows = (totals: IDoorTotals, useAsFilteredTotals?: boolean) => ({
    payload: { totals, useAsFilteredTotals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS.CALCULATION_RETURNED,
});

export const calculationsFilteredReturnedForMatchingRows = (totals: IDoorTotals) => ({
    payload: { totals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS_FILTERED.CALCULATION_RETURNED,
});

export const setDoorTotalRow = (totals: IDoorTotalRow) => ({
    payload: { totals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTAL_ROW_FILTERED.CALCULATION_RETURNED,
});

export const setDoorTotalDeltaQueue = (doorTotals: IDoorTotalDelta[]) => ({
    payload: { queue: doorTotals },
    type: COLLECTIONS.COLLECTION.DOOR_TOTALS.SET_DOOR_TOTAL_DELTA_QUEUE,
});

/* DEMO BUDGETS */
const { CREATE, FETCH, UPDATE, DELETE } = COLLECTIONS.COLLECTION.BUDGET;

export const createBudget = (collectionId, budget) => ({
    payload: { collectionId, budget },
    type: CREATE.START,
});

export const createBudgetCompleted = (collectionId, budget) => ({
    payload: { collectionId, budget },
    type: CREATE.COMPLETED,
});

export const fetchBudgets = (collectionId) => ({
    payload: { collectionId },
    type: FETCH.START,
});

export const fetchBudgetsCompleted = (collectionId, budgets) => ({
    payload: { collectionId, budgets },
    type: FETCH.COMPLETED,
});

export const updateBudget = (collectionId, budget) => ({
    payload: { collectionId, budget },
    type: UPDATE.START,
});

export const updateBudgetCompleted = (collectionId, budget) => ({
    payload: { collectionId, budget },
    type: UPDATE.COMPLETED,
});

export const deleteBudget = (collectionId, budgetId) => ({
    payload: { collectionId, budgetId },
    type: DELETE.START,
});

export const deleteBudgetCompleted = (collectionId, budgetId) => ({
    payload: { collectionId, budgetId },
    type: DELETE.COMPLETED,
});

export const mutateBudget = (collectionId: string, value: any) => ({
    payload: { collectionId, value },
    type: COLLECTIONS.COLLECTION_BUDGET.MUTATE,
});
